
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 108.02 121.522"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#29ABE2","d":"M0 54.01h108.019v67.513H0z"}}),_c('path',{attrs:{"fill":"#F26522","d":"M0 54.01L54.01 0l54.009 54.01zM40.508 67.512h27.005v27.005H40.508z"}})])
          )
        }
      }
    